/* Layout */
import Layout from '@/views/layout/layout'
import LayoutInfo from '@/views/layout/layout-info'
import LayoutDefault from '@/views/layout/layout-default'
// import Main from '@/views/layout/app-main'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/utils/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    component: Layout,
    children: [
      // 首页
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: {
          title: '首页',
          auth: true
        },
        component: _import('/system/dashboard')
      },
      {
        path: 'reportIndex',
        name: 'reportIndex',
        meta: { title: '报表' },
        component: _import('/report/index')
      },

      // {
      //   path: 'my',
      //   name: 'myIndex',
      //   meta: { title: '我的' },
      //   component: _import('/platform/my/index')
      // },

      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('/system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('/system/function/redirect')
      }
    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  {
    path: '/dap',
    name: 'dap',
    meta: {
      title: '大屏'
    },
    component: _import('/report/mrp/dap')
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: _import('/system/login')
  },
  {
    path: '/form-renderer-preview',
    name: 'form-renderer-preview',
    meta: {
      title: '预览',
      auth: false
    },
    component: _import('/form/formrender/preview')
  },
  {
    path: '/iframe',
    name: 'iframe',
    meta: {
      title: 'iframe'
    },
    component: _import('/system/iframe')
  },
  {
    path: '/uuc',
    name: 'uucGateway',
    meta: {
      title: '办理',
      auth: false
    },
    component: _import('/system/login/uuc')
  },
  {
    path: '/jump',
    name: 'jumpGateway',
    component: _import('/jump'),
    meta: {
      title: '详情',
      auth: false
    }
  },
  {
    path: '/gateway',
    name: 'gateway',
    component: _import('/gateway'),
    meta: {
      title: '详情',
      auth: false
    }
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '/404',
    name: 'error404',
    meta: {
      title: '404-页面不存在',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/404')
  },
  {
    path: '/401',
    name: 'error401',
    meta: {
      title: '401- 未授权',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/401')
  },
  {
    path: '/403',
    name: 'error403',
    meta: {
      title: '403-权限不足',
      auth: false
    },
    hidden: true,
    component: _import('/system/error/403')
  }
]

// 自定义
const frameCustom = [
  {
    path: '/onlineForm/index',
    name: 'onlineForm',
    meta: {
      title: '办理',
      auth: false
    },
    component: _import('/approval/index')
  },
  {
    path: '/next-menu',
    redirect: 'index',
    component: LayoutInfo,
    children: [
      {
        path: 'index',
        name: 'next-menu',
        meta: { title: '更多', icon: 'dashboard' },
        component: _import('/system/dashboard/next-menu')
      }

    ]

  },
  {
    path: '/more',
    name: 'more',
    component: _import('/home/more'),
    meta: {
      title: '常用功能'
    }
  },
  // {
  //   path: '/kms/kmsKnowledgeMine',
  //   name: 'kmsKnowledgeMine',
  //   component: _import('/kms/kmsKnowledgeMine'),
  //   meta: {
  //     title: '我的知识'
  //   }
  // },
  // {
  //   path: '/message',
  //   component: Layout,
  //   redirect: 'index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'message',
  //       meta: { title: '消息', icon: 'message' },
  //       component:_import('/message/index')
  //     }, {
  //       path: 'chat',
  //       name: 'chat',
  //       meta: { title: '聊天', icon: 'message' },
  //       component:_import('/message/index')
  //     }
  //   ]
  // },
  {
    path: '/notice',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'notice',
        meta: { title: '公告', icon: 'notice' },
        component: _import('/platform/notice/index')
      }
    ]
  },
  {
    path: '/contacts',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'contacts',
        meta: { title: '通讯录', icon: 'contacts' },
        component: _import('/platform/contacts/index')
      }
    ]
  },
  {
    path: '/my',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'my',
        meta: { title: '我的', icon: 'my' },
        component: _import('/platform/my/index')
      },
      {
        path: 'userInfo',
        name: 'userInfo',
        meta: { title: '个人信息', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/user-info')
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        meta: { title: '修改密码', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/change-password')
      },
      // {
      //   path: 'setting',
      //   name: 'setting',
      //   meta: { title: '设置', icon: 'my', isLeftBar: true, isShowBar: false },
      //   component:_import('/platform/my/setting')
      // },
      {
        path: 'help',
        name: 'help',
        meta: { title: '帮助', icon: 'help', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/help')
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        meta: { title: '关于我们', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/about-us')

      },
      {
        path: 'attendanceResults',
        name: 'attendanceResults',
        meta: { title: '考勤统计', icon: 'my', isLeftBar: true, isShowBar: false },
        component: _import('/platform/my/attendanceResults')
      }
    ]
  },
  {
    path: '/dingtalk',
    redirect: 'pending',
    component: LayoutDefault,
    children: [
      {
        // 待办/已办/草稿/我的申请
        // http://localhost:9628/#/dingtalk/bpmn/task?instId=1579670203192061953
        // 待办/已办
        // http://localhost:9628/#/dingtalk/bpmn/task?taskId=ca086f9b-4913-11ed-8694-ba941737fc35
        path: 'bpmn/task',
        name: 'dingtalkBpmnTask',
        meta: { title: '流程审批' },
        component: _import('/platform/dingtalk/bpmn/task/index')
      }
    ]
  },
  {
    path: '/report',
    redirect: 'payInfo',
    component: LayoutDefault,
    children: [
      {
        path: 'pay',
        name: 'reportPayInfo',
        meta: { title: '付款明细' },
        component: _import('/report/pages/payInfo')
      },
      {
        path: 'collectMoneyInfo',
        name: 'collectMoneyInfo',
        meta: { title: '收款明细' },
        component: _import('/report/pages/collectMoneyInfo')
      },
      {
        path: 'bankCashBalanceAccount',
        name: 'bankCashBalanceAccount',
        meta: { title: '银行现金余额账' },
        component: _import('/report/pages/bankCashBalanceAccount')
      },
      {
        path: 'bankCashBalanceAccountInfo',
        name: 'bankCashBalanceAccountInfo',
        meta: { title: '银行现金余额明细' },
        component: _import('/report/pages/bankCashBalanceAccountInfo')
      },
      {
        path: 'receivableAccount',
        name: 'receivableAccount',
        meta: { title: '应收票据余额账' },
        component: _import('/report/pages/receivableAccount')
      },
      {
        path: 'receivableAccountInfo',
        name: 'receivableAccountInfo',
        meta: { title: '应收票据余额明细' },
        component: _import('/report/pages/receivableAccountInfo')
      },
      {
        path: 'dailyPaper',
        name: 'dailyPaper',
        meta: { title: '资金日报' },
        component: _import('/report/pages/dailyPaper')
      },
      {
        path: 'dailyPaperInfo',
        name: 'dailyPaperInfo',
        meta: { title: '资金日报明细' },
        component: _import('/report/pages/dailyPaperInfo')
      },
      {
        path: 'fundChangeSum',
        name: 'fundChangeSum',
        meta: { title: '资金变动统计' },
        component: _import('/report/pages/fundChangeSum')
      },
      {
        path: 'fundChangeSumInfo',
        name: 'fundChangeSumInfo',
        meta: { title: '资金变动统计明细' },
        component: _import('/report/pages/fundChangeSumInfo')
      },
      {
        path: 'paySum',
        name: 'paySum',
        meta: { title: '付款情况统计' },
        component: _import('/report/pages/paySum')
      },
      {
        path: 'paySumInfo',
        name: 'paySumInfo',
        meta: { title: '付款情况统计明细' },
        component: _import('/report/pages/paySumInfo')
      },
      {
        path: 'collectMoneySum',
        name: 'collectMoneySum',
        meta: { title: '收款情况统计' },
        component: _import('/report/pages/collectMoneySum')
      },
      {
        path: 'collectMoneySumInfo',
        name: 'collectMoneySumInfo',
        meta: { title: '收款情况统计明细' },
        component: _import('/report/pages/collectMoneySumInfo')
      }

    ]
  },
  {
    path: '/bpmn',
    redirect: 'pending',
    component: LayoutDefault,
    children: [
      // 具体参数方式
      // 发起
      // http://localhost:9628/#/bpmn/middle/form/index?defId=1404804933668061185
      // 待办
      // http://localhost:9628/#/bpmn/middle/form/index?taskId=d9d731ac-1d0a-11ec-a113-32234a7cf847
      // 已办
      // http://localhost:9628/#/bpmn/middle/form/index?instId=1441288102059388929&taskId=76eb99f0-1d00-11ec-a113-32234a7cf847
      // 草稿
      // http://localhost:9628/#/bpmn/middle/form/index?defId=1579049889550635009&proInstId=1579713485058093058
      // 我的申请
      // http://192.168.7.219:9628/#/bpmn/form?instId=1579670203192061953
      {
        path: 'form',
        name: 'bpmnForm',
        meta: { title: '流程审批' },
        component: _import('/platform/bpmn/form/index')
      },
      // 只传taskId/instId
      // 待办/已办
      // http://localhost:9628/#/bpmn/task?taskId=5c790679-4867-11ed-8b04-ba941737fc35
      // 待办/已办/草稿/我的申请
      // http://localhost:9628/#/dingtalk/bpmn/task?instId=1579670203192061953
      {
        path: 'task',
        name: 'bpmnTask',
        meta: { title: '流程审批' },
        component: _import('/platform/bpmn/form/task/index')
      },

      // 菜单路由
      {
        path: 'pending/index',
        name: 'pending',
        meta: { title: '待办事宜' },
        component: _import('/platform/bpmn/pending/index')
      },
      {
        path: 'pending-matter/index',
        name: 'pendingMatter',
        meta: { title: '待办事宜' },
        component: _import('/platform/bpmn/pending-matter/index')
      },
      {
        path: 'pending-cc/index',
        name: 'pending-cc',
        meta: { title: '抄送' },
        component: _import('/platform/bpmn/pending-cc/index')
      },

      {
        path: 'kms/index',
        name: 'kms',
        meta: { title: '知识首页' },
        component: _import('/platform/bpmn/kms/index')
      },
      {
        path: 'kms/index-mine',
        name: 'kmsMine',
        component: _import('/platform/bpmn/kms/index-mine')
      },
      {
        path: 'kms/indexDtl',
        name: 'kmsDtl',
        meta: { title: '知识详情' },
        component: _import('/platform/bpmn/kms/indexDtl')
      },
      {
        path: 'kms/indexLeftDtl',
        name: 'kmsLeftDtl',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtl')
      },
      {
        path: 'kms/indexLeftDtlData',
        name: 'kmsLeftDtlData',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtlData')
      },
      {
        path: 'kms/indexLeftDtlData1',
        name: 'kmsLeftDtlData1',
        meta: { title: '知识目录' },
        component: _import('/platform/bpmn/kms/indexLeftDtlData1')
      },
      {
        path: 'completed/index',
        name: 'completed',
        meta: { title: '办结事宜' },
        component: _import('/platform/bpmn/completed/index')
      },
      {
        path: 'handled/index',
        name: 'handled',
        meta: { title: '已办事宜' },
        component: _import('/platform/bpmn/handled/index')
      },
      {
        path: 'myRequest/index',
        name: 'myRequest',
        meta: { title: '我的申请' },
        component: _import('/platform/bpmn/my-request/index')
      },
      {
        path: 'newProcess/index',
        name: 'newProcess',
        meta: { title: '发起申请' },
        component: _import('/platform/bpmn/new-process/index')
      },
      {
        path: 'myDraft/index',
        name: 'myDraft',
        meta: { title: '我的草稿' },
        component: _import('/platform/bpmn/my-draft/index')
      },
      {
        path: 'myRevoke/index',
        name: 'myRevoke',
        meta: { title: '可撤销事务' },
        component: _import('/platform/bpmn/my-revoke/index')
      },
      {
        path: 'myCompleted/index',
        name: 'myCompleted',
        meta: { title: '我结束的流程' },
        component: _import('/platform/bpmn/my-completed/index')
      },

      {
        path: 'taskChange/index',
        name: 'taskChange',
        meta: { title: '我的转办代理' },
        component: _import('/platform/bpmn/task-change/index')
      },
      {
        path: 'taskChangeDetail',
        name: 'taskChangeDetail',
        meta: { title: '详细信息' },
        component: _import('/platform/bpmn/task-change/detail')
      }
    ]
  },
  {
    path: '/message/inner/receive',
    component: _import('/platform/message/inner/receive'),
    name: 'messageInnerReceive',
    meta: { title: '我的消息' }
  },
  {
    path: '/d/list/:id(\\w+)',
    component: _import('/platform/data/template-list'),
    name: 'dataTemplateList',
    meta: { title: '模版' }
  },
  // {
  //   path: '/d/form',
  //   component:_import('/platform/data/template-form'),
  //   name: 'dataTemplateform',
  //   meta: { title: '表单明细' }
  // },
  {
    path: '/demo',
    component: LayoutInfo,
    redirect: 'form',
    children: [
      {
        path: 'form',
        name: 'demoForm',
        meta: { title: '表单Demo', icon: 'table' },
        component: _import('/demo/form')
      }
      // {
      //   path: '1',
      //   name: 'demoForm1',
      //   meta: { title: '权限申请', icon: 'table' },
      //   component: _import('/oa/oaGemsPermission')
      // }
      //     {
      //       path: 'toolbar',
      //       name: 'demoToolbar',
      //       meta: { title: '工具栏', icon: 'toolbar' },
      //       component:_import('/demo/toolbar')
      //     }
    ]
  },
  {
    path: '/hr',
    component: LayoutDefault,
    redirect: 'applicationRegistration',
    children: [
      {
        path: 'applicationRegistration',
        name: 'applicationRegistrationForm',
        meta: { title: '应聘登记', icon: 'table' },
        component: _import('/hr/applicationRegistration')
      },
      {
        path: 'applicationRegistrationOK',
        name: 'applicationRegistrationOKForm',
        meta: { title: '提交成功', icon: 'table' },
        component: _import('/hr/applicationRegistrationOK')
      },
      {
        path: 'hrRecruiRegisterRecord',
        name: 'hrRecruiRegisterRecordForm',
        meta: { title: '入职登记', icon: 'table' },
        component: _import('/hr/hrRecruiRegisterRecord')
      },
      {
        path: 'hrRecruiRegisterRecordForm',
        name: 'hrRecruiRegisterRecordFromForm',
        meta: { title: '入职登记表单', icon: 'table' },
        component: _import('/hr/hrRecruiRegisterRecordForm')
      }
    ]
  },
  {
    path: '/pms',
    redirect: 'pmsCheckTask',
    component: LayoutDefault,
    children: [
      {
        path: 'pmsCheckTask/index',
        name: 'pmsCheckTask',
        meta: { title: '设备点检', icon: 'table' },
        component: _import('/pms/check-task')
      },
      {
        path: 'pmsDeviceRepair/index',
        name: 'pmsDeviceRepair',
        meta: { title: '设备报修', icon: 'table' },
        component: _import('/pms/device-repair')
      }
    ] },
  {
    path: '/pms',
    redirect: 'pmsMaintainTask',
    component: LayoutDefault,
    children: [
      {
        path: 'pmsMaintainTask/index',
        name: 'pmsMaintainTask',
        meta: { title: '设备维保', icon: 'table' },
        component: _import('/pms/maintain-task')
      }
    ] },
  { path: '*', redirect: '/404', hidden: true }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage,
  ...frameCustom
]
